import mapKeys from 'lodash/mapKeys'

import { FAMILY_ALBUM_URL } from 'Global/constants'

import { SIGN_OUT } from 'Global/Stores/auth'

const FAMILY_ALBUM_EVENTS_GET = 'API|FAMILY_ALBUM/EVENTS/GET'
const FAMILY_ALBUM_EVENTS_GET_FULFILLED = `FULFILLED_${FAMILY_ALBUM_EVENTS_GET}`
const FAMILY_ALBUM_EVENTS_GET_PENDING = `PENDING_${FAMILY_ALBUM_EVENTS_GET}`
const FAMILY_ALBUM_EVENTS_GET_REJECTED = `REJECTED_${FAMILY_ALBUM_EVENTS_GET}`

export const FAMILY_ALBUM_FILTERS_SET = 'FAMILY_ALBUM/FILTERS/SET'

const FAMILY_ALBUM_SEARCH_FORM_TOGGLE = 'FAMILY_ALBUM/SEARCH_FORM/TOGGLE'

const FAMILY_ALBUM_CUSTOMERS_EXPORT_EXCEL = 'API|FAMILY_ALBUM/EXPORT/EXCEL'
export const FAMILY_ALBUM_CUSTOMERS_EXPORT_EXCEL_FULFILLED = `FULFILLED_${FAMILY_ALBUM_CUSTOMERS_EXPORT_EXCEL}`

/**
 * GET request to the Family Album API to get all events.
 */
export const familyAlbumEventsGet = () => {
  return {
    meta: { externalUrl: `${FAMILY_ALBUM_URL}/api/v1/event/carpet` },
    type: FAMILY_ALBUM_EVENTS_GET,
  }
}

export const familyAlbumFiltersSet = filters => {
  return { payload: filters, type: FAMILY_ALBUM_FILTERS_SET }
}

export const familyAlbumSearchFormToggle = () => {
  return { type: FAMILY_ALBUM_SEARCH_FORM_TOGGLE }
}

/**
 * POST request to the api to export customers to an excel file.
 * Limited to 1000 customers.
 * @param {array} customers - Customers to export.
 * @returns {object} Action object.
 */
export const customersExportExcel = customers => ({
  meta: {
    data: { customers: customers.slice(0, 1000) },
    errorMessage: `Error exporting to Excel. Please try again.`,
    method: 'post',
    responseType: 'arraybuffer',
    successMessage: `Exported event customers.`,
    url: '/api/v1/excel/customers',
  },
  type: FAMILY_ALBUM_CUSTOMERS_EXPORT_EXCEL,
})

const initialState = {
  data: {},
  done: false,
  error: false,
  filters: { email: '' },
  isSearchVisible: true,
  pending: false,
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case FAMILY_ALBUM_EVENTS_GET_FULFILLED:
      return {
        ...state,
        data: mapKeys(payload.data, 'id'),
        done: true,
        error: false,
        pending: false,
      }

    case FAMILY_ALBUM_EVENTS_GET_PENDING:
      return {
        ...state,
        done: false,
        error: false,
        pending: true,
      }

    case FAMILY_ALBUM_EVENTS_GET_REJECTED:
      return {
        ...state,
        done: true,
        error: true,
        pending: false,
      }

    case FAMILY_ALBUM_FILTERS_SET:
      return {
        ...state,
        filters: payload,
      }

    case FAMILY_ALBUM_SEARCH_FORM_TOGGLE:
      return {
        ...state,
        isSearchVisible: !state.isSearchVisible,
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
